import { CommonModule } from '@angular/common';
import { SeoNavbarModule } from '../app/navigation/seo-navbar/seo-navbar.module';
import * as i0 from "@angular/core";
export class CompatSeoNavbarModule {
}
CompatSeoNavbarModule.ɵfac = function CompatSeoNavbarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSeoNavbarModule)(); };
CompatSeoNavbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompatSeoNavbarModule });
CompatSeoNavbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [SeoNavbarModule, CommonModule] });
